
import { Component, Vue } from 'vue-property-decorator';
import { regAccount } from '@/api/users';
import { checkPicVerifyCode, getCode } from '@/api/other';

@Component({
  name: 'Register'
})
export default class extends Vue {
  private formRegister: any = {
    company: '',
    name: '',
    mobile: '',
    authcode: '',
    version: '0',
    agreement: '',
    picCode: '',
    picInputCode: ''
  }
  created() {
    if (this.$route.query && this.$route.query.sjh) {
      this.$set(this.formRegister, 'mobile', this.$route.query.sjh);
    }
  }
  private dialogVerifyCodeVisible=false;

  private loginUrl=location.protocol + process.env.VUE_APP_LOGIN_URL
  private registerAccount() {
    if (!this.formRegister.company) {
      this.showErrorMsg('请输入5～30位由字母、数字、中文、下划线、小括号（中英文）组成的公司名称');
      return;
    }
    if (this.formRegister && this.formRegister.company) {
      var companyNameRegex = /^[\u4E00-\u9FA5a-zA-Z0-9-_\\(\\)\\（\\）]{5,30}$/;
      if (!companyNameRegex.test(this.formRegister.company)) {
        this.showErrorMsg('请输入5～30位由字母、数字、中文、下划线、小括号（中英文）组成的公司名称');
      }
    }
    if (!this.formRegister.name) {
      this.showErrorMsg('请输入姓名');
      return;
    }
    if (this.formRegister.name.length < 2 || this.formRegister.name.length > 30) {
      this.showErrorMsg('请输入2-30位的姓名');
      return;
    }
    if (!this.formRegister.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (this.formRegister.mobile) {
      var telRegex = /^1\d{10}$/;
      if (!telRegex.test(this.formRegister.mobile)) {
        this.showErrorMsg('请输入正确的手机号');
        return;
      }
    }
    if (!this.formRegister.authcode) {
      this.showErrorMsg('请输入验证码');
      return;
    }
    if (this.formRegister.authcode.length < 4 || this.formRegister.authcode.length > 6) {
      this.showErrorMsg('请输入4-6位验证码');
      return;
    }
    if (parseInt(this.formRegister.version) === 0) {
      this.showErrorMsg('请选择版本');
      return;
    }
    if (!this.formRegister.agreement) {
      this.showErrorMsg('请先勾选下方注册相关服务选项');
      return;
    }
    let pamars:any = {};
    pamars.company_name = this.formRegister.company;
    pamars.company_vip_level = this.formRegister.version;
    pamars.name = this.formRegister.name;
    pamars.mobile = this.formRegister.mobile;
    pamars.verify_code = this.formRegister.authcode;
    regAccount(pamars).then(res => {
      this.showSecussMsg('注册成功');
      window.parent.frames.location.href = location.protocol + process.env.VUE_APP_URL_JUMP;
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private sendCodeClick() {
    if (this.timedown < 60) {
      return;
    }
    this.sendCode(1);
  }
  private sendCode(type:number) {
    if (!this.formRegister.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (this.formRegister.mobile) {
      var telRegex = /^1\d{10}$/;
      if (!telRegex.test(this.formRegister.mobile)) {
        this.showErrorMsg('请输入正确的手机号');
        return;
      }
    }
    let map:any = {};
    map.send_type = 11;
    map.mobile = this.formRegister.mobile;
    getCode(map).then(res => {
      if (res.data && res.data.image_code) {
        this.formRegister.picCode = res.data.image_code;
        if (type === 1) {
          this.$set(this.formRegister, 'picInputCode', '');
          this.dialogVerifyCodeVisible = true;
        }
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private imgVerifyClick() {
    this.sendCode(0);
  }
  private timedown:any = 60;
  private sendtext = '发送验证码';
  private timer:any = '';
  private checkPicVerify() {
    let map:any = {};
    map.send_type = 11;
    map.mobile = this.formRegister.mobile;
    map.image_code = this.formRegister.picInputCode;
    checkPicVerifyCode(map).then(res => {
      this.showSecussMsg('验证码已发送');
      this.dialogVerifyCodeVisible = false;
      this.sendtext = this.timedown + 's';
      this.timer = setInterval(() => {
        this.timedown--;
        if (this.timedown <= 0) {
          clearInterval(this.timer);
          this.timedown = 60;
          this.sendtext = '重新获取';
          return;
        }
        this.sendtext = this.timedown + 's';
      }, 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
